var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ies-form-field", { attrs: { field: _vm.field } }, [
    _c(
      "div",
      { staticClass: "d-flex flex-column" },
      [
        _c("input", {
          attrs: { type: "hidden", name: _vm.field.fieldName },
          domProps: { value: _vm.field.value },
        }),
        _vm._v(" "),
        _c(
          "v-radio-group",
          {
            attrs: { row: "", autocomplete: "" },
            model: {
              value: _vm.status,
              callback: function ($$v) {
                _vm.status = $$v
              },
              expression: "status",
            },
          },
          [
            _c("v-radio", { attrs: { label: "Offline", value: 0 } }),
            _vm._v(" "),
            _c("v-radio", { attrs: { label: "Previewable", value: 2 } }),
            _vm._v(" "),
            _c("v-radio", { attrs: { label: "Online", value: 1 } }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }